import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  //本地调试关闭，上线发布打开
  // base: '/admin',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('./views/Index.vue'),
      redirect: '/homepage',
      children: [
        {
          path: '/homepage',      //首页
          name: 'homepage',
          component: () => import('./views/Homepage.vue'),
          meta: {
            title: '首页',
            auth: true
          }
        },
        {
          path: '/rolelist',
          name: 'rolelist',
          component: () => import('./views/Rolelist.vue'),
          meta: {
            title: '管理员列表',
            auth: true
          }
        },
        {
          path: '/reportconfig',
          name: 'reportconfig',
          component: () => import('./views/ReportConfig.vue'),
          meta: {
            title: '报备字段可配置',
            auth: true
          }
        },
        {
          path: '/jurisdiction',
          name: 'jurisdiction',
          component: () => import('./views/Jurisdiction.vue'),
          meta: {
            title: '角色组',
            auth: true
          }
        },
        {
          path: '/message',
          name: 'message',
          component: () => import('./views/Message.vue'),
          meta: {
            title: '短信管理',
            auth: true
          }
        },
        {
          path: '/bbquery',      //报备查询
          name: 'bbquery',
          component: () => import('./views/Bbquery.vue'),
          meta: {
            title: '报备查询',
            auth: true
          }
        },
        {
          path: '/bbquery/product',      //报备查询
          name: 'bbqueryProduct',
          component: () => import('./views/BbqueryProduct.vue'),
          meta: {
            title: '溯源信息',
            auth: true
          }
        },
        {
          path: '/inter',    //网站管理
          name: 'inter',
          component: () => import('./views/Inter.vue'),
          redirect: '/country',
          meta: {
            title: '网站管理',
            auth: true
          },
          children: [
            {
              path: '/agreement',    //基础信息
              name: 'agreement',
              component: () => import('./views/Agreement.vue'),
              meta: {
                title: '基础信息',
                auth: true
              }
            },
            {
              path: '/agreengl',    //协议管理
              name: 'agreengl',
              component: () => import('./views/Agreengl.vue'),
              meta: {
                title: '协议管理',
                auth: true
              }
            },
          ]
        },
        {
          path: '/report',    //统计查询
          name: 'report',
          component: () => import('./views/report/Index.vue'),
          redirect: '/bbei',
          meta: {
            title: '报备统计',
            auth: true
          },
          children: [
            {
              path: '/bbei',    //报备统计
              name: 'bbei',
              component: () => import('./views/report/Bbei.vue'),
              meta: {
                title: '报备统计',
                auth: true
              }
            },
            {
              path: '/byan',    //办宴统计
              name: 'byan',
              component: () => import('./views/report/Byan.vue'),
              meta: {
                title: '办宴统计',
                auth: true
              }
            },
            {
              path: '/xchu',    //乡厨统计
              name: 'xchu',
              component: () => import('./views/report/Xchu.vue'),
              meta: {
                title: '乡厨统计',
                auth: true
              }
            },
            {
              path: '/gli',    //乡厨统计
              name: 'gli',
              component: () => import('./views/report/Gli.vue'),
              meta: {
                title: '管理员统计',
                auth: true
              }
            },
            {
              path: '/week',    //乡厨统计
              name: 'week',
              component: () => import('./views/report/Week.vue'),
              meta: {
                title: '周报表',
                auth: true
              }
            },
            {
              path: '/day',    //乡厨统计
              name: 'day',
              component: () => import('./views/report/Day.vue'),
              meta: {
                title: '日报表',
                auth: true
              }
            },
          ]
        },
        {
          path: '/refresh',    //刷新页面后退路由
          name: 'refresh',
          component: () => import('./views/refresh.vue'),
        },
        {
          path: '/roleg',    //角色管理
          name: 'roleg',
          component: () => import('./views/role/Index.vue'),
          redirect: '/country',
          meta: {
            title: '角色管理',
            auth: true
          },
          children: [
            {
              path: '/country',    //乡厨管理
              name: 'country',
              component: () => import('./views/role/Country.vue'),
              meta: {
                title: '乡厨管理',
                auth: true
              }
            },
            {
              path: '/sabrole',    //食安办管理
              name: 'sabrole',
              component: () => import('./views/role/Sabrole.vue'),
              meta: {
                title: '食安办管理',
                auth: true
              }
            },
            {
              path: '/assist',    //协管理员
              name: 'assist',
              component: () => import('./views/role/Assist.vue'),
              meta: {
                title: '协管员管理',
                auth: true
              }
            },
            {
              path: '/help',    //帮厨管理
              name: 'help',
              component: () => import('./views/role/Help.vue'),
              meta: {
                title: '帮厨管理',
                auth: true
              }
            },
          ]
        },
        {
          path: '/exam',    //考试模块
          name: 'exam',
          component: () => import('./views/role/Index.vue'),
          redirect: '/know',
          meta: {
            title: '培训考试',
            auth: true
          },
          children: [
            {
              path: '/know',    //知识管理
              name: 'know',
              component: () => import('./views/exam/Know.vue'),
              meta: {
                title: '知识管理',
                auth: true
              }
            },{
              path: '/footage',    //知识管理
              name: 'footage',
              component: () => import('./views/exam/Video.vue'),
              meta: {
                title: '视频管理',
                auth: true
              }
            },{
              path: '/banner',    //轮播管理
              name: 'banner',
              component: () => import('./views/exam/Banner.vue'),
              meta: {
                title: 'banner管理',
                auth: true
              }
            },{
              path: '/question',    //轮播管理
              name: 'question',
              component: () => import('./views/exam/Question.vue'),
              meta: {
                title: '题库管理',
                auth: true
              }
            },{
              path: '/answer',    //轮播管理
              name: 'answer',
              component: () => import('./views/exam/Answer.vue'),
              meta: {
                title: '答题管理',
                auth: true
              }
            }
          ]
        },
        {
          path: '/user',    //人员管理模块
          name: 'user',
          component: () => import('./views/user/Index.vue'),
          redirect: '/know',
          meta: {
            title: '人员管理',
            auth: true
          },
          children: [
            {
              path: '/userlist',    //知识管理
              name: 'userlist',
              component: () => import('./views/user/Userlist.vue'),
              meta: {
                title: '用户列表',
                auth: true
              }
            },{
              path: '/location',    //地址管理
              name: 'location',
              component: () => import('./views/user/Location.vue'),
              meta: {
                title: '地址管理',
                auth: true
              }
            },{
              path: '/integral',    //积分活动
              name: 'integral',
              component: () => import('./views/user/Integral.vue'),
              meta: {
                title: '积分活动',
                auth: true
              }
            }
          ]
        },
        {
          path: '/coupon',    //优惠券模块
          name: 'coupon',
          component: () => import('./views/coupons/Index.vue'),
          redirect: '/coupons',
          meta: {
            title: '优惠券列表',
            auth: true
          },
          children: [
            {
              path: '/coupons',    //优惠券列表
              name: 'coupons',
              component: () => import('./views/coupons/Coupons.vue'),
              meta: {
                title: '优惠券列表',
                auth: true
              }
            }
          ]
        },
        {
          path: '/indent',    //订单管理模块
          name: 'indent',
          component: () => import('./views/indent/Index.vue'),
          redirect: '/indets',
          meta: {
            title: '订单管理',
            auth: true
          },
          children: [
            {
              path: '/indents',    //订单列表
              name: 'indents',
              component: () => import('./views/indent/Indents.vue'),
              meta: {
                title: '订单列表',
                auth: true
              }
            }
          ]
        },
        {
          path: '/commodity',    //商品管理
          name: 'commodity',
          component: () => import('./views/commodity/Index.vue'),
          redirect: '/evaluate',
          meta: {
            title: '订单管理',
            auth: true
          },
          children: [
            {
              path: '/evaluate',    //商品管理
              name: 'evaluate',
              component: () => import('./views/commodity/Evaluate.vue'),
              meta: {
                title: '商品评价管理',
                auth: true
              }
            },{
              path: '/classify',    //商品分类
              name: 'classify',
              component: () => import('./views/commodity/Classify.vue'),
              meta: {
                title: '商品分类',
                auth: true
              }
            },{
              path: '/articles',    //商品列表
              name: 'articles',
              component: () => import('./views/commodity/Article.vue'),
              meta: {
                title: '商品列表',
                auth: true
              }
            },{
              path: '/events',    //活动管理
              name: 'events',
              component: () => import('./views/commodity/Events.vue'),
              meta: {
                title: '活动管理',
                auth: true
              }
            },{
              path: '/recommend',    //推荐管理
              name: 'recommend',
              component: () => import('./views/commodity/Recommend.vue'),
              meta: {
                title: '推荐管理',
                auth: true
              }
            },{
              path: '/shopban',    //商城banner管理
              name: 'shopban',
              component: () => import('./views/commodity/Shopban.vue'),
              meta: {
                title: 'banner管理',
                auth: true
              }
            },{
              path: '/keyword',    //关键词管理
              name: 'keyword',
              component: () => import('./views/commodity/Keyword.vue'),
              meta: {
                title: '关键词管理',
                auth: true
              }
            }
          ]
        },
        {
          path: '/carriage',    //车辆溯源
          name: 'carriage',
          component: () => import('./views/carriage/Index.vue'),
          redirect: '/vehicle',
          meta: {
            title: '培训考试',
            auth: true
          },
          children: [
            {
              path: '/vehicle',    //车辆管理
              name: 'vehicle',
              component: () => import('./views/carriage/Vehicle.vue'),
              meta: {
                title: '车辆管理',
                auth: true
              }
            },
            {
              path: '/driver',    //司机管理
              name: 'driver',
              component: () => import('./views/carriage/Driver.vue'),
              meta: {
                title: '司机管理',
                auth: true
              }
            },
            {
              path: '/transport',    //运输管理
              name: 'transport',
              component: () => import('./views/carriage/Transport.vue'),
              meta: {
                title: '运输管理',
                auth: true
              }
            }
          ]
        },
        {
          path: '/purchase',    //采购溯源
          name: 'purchase',
          component: () => import('./views/purchase/Index.vue'),
          redirect: '/buyer',
          meta: {
            title: '培训考试',
            auth: true
          },
          children: [
            {
              path: '/buyer',    //采购员管理
              name: 'buyer',
              component: () => import('./views/purchase/Buyer.vue'),
              meta: {
                title: '采购员管理',
                auth: true
              }
            },
            {
              path: '/supplier',    //供应商管理
              name: 'supplier',
              component: () => import('./views/purchase/Supplier.vue'),
              meta: {
                title: '供应商管理',
                auth: true
              }
            },
            {
              path: '/ingredient',    //食材管理
              name: 'ingredient',
              component: () => import('./views/purchase/Ingredient.vue'),
              meta: {
                title: '食材管理',
                auth: true
              }
            },
          ]
        },
        {
          path: '/site',    //站点管理
          name: 'site',
          component: () => import('./views/site/Index.vue'),
          redirect: '/sites',
          meta: {
            title: '站点管理',
            auth: true
          },
          children: [
            {
              path: '/sites',    //站点管理
              name: 'sites',
              component: () => import('./views/site/Site.vue'),
              meta: {
                title: '站点列表',
                auth: true
              }
            }
          ]
        },
        {
          path: '/dinner',    //办宴点管理
          name: 'dinner',
          component: () => import('./views/dinner/Index.vue'),
          redirect: '/dinners',
          meta: {
            title: '办宴点管理',
            auth: true
          },
          children: [
            {
              path: '/dinners',    //办宴列表
              name: 'dinners',
              component: () => import('./views/dinner/Dinners.vue'),
              meta: {
                title: '办宴点管理',
                auth: true
              }
            },{
              path: '/camera',    //监控列表
              name: 'camera',
              component: () => import('./views/dinner/Camera.vue'),
              meta: {
                title: '摄像头管理',
                auth: true
              }
            }
          ]
        },
      ]
    },
    {
      path: '/Hadoops',    //大数据
      name: 'Hadoops',
      component: () => import('./views/Hadoop/Index.vue'),
      redirect: '/Hadoop',
      meta: {
        title: '大数据',
        auth: true
      },
      children: [
        {
          path: '/Hadoop',    //大数据
          name: 'Hadoop',
          component: () => import('./views/Hadoop/Hadoop.vue'),
          meta: {
            title: '乡村群宴大数据可视化平台',
            auth: true
          }
        }
      ]
    },
  ],
});
